function initCreativeOBDEnquiry(root = document) {
  root.querySelectorAll('[data-cobd-length-select]').forEach((select) => {
    if (select.dataset.cobdLengthReady === 'true') return;

    const form = select.closest('form');
    const exception = form?.querySelector('[data-cobd-nonstandard-length]');
    const exceptionInput = exception?.querySelector('input');
    if (!exception || !exceptionInput) return;

    const updateLengthException = () => {
      const selectedOption = select.options[select.selectedIndex];
      const nonStandardSelected = selectedOption?.hasAttribute('data-cobd-nonstandard-option');
      exception.hidden = !nonStandardSelected;
      exceptionInput.required = Boolean(nonStandardSelected);
      exceptionInput.setAttribute('aria-required', nonStandardSelected ? 'true' : 'false');
      if (!nonStandardSelected) exceptionInput.value = '';
    };

    select.dataset.cobdLengthReady = 'true';
    select.addEventListener('change', updateLengthException);
    updateLengthException();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCreativeOBDEnquiry());
} else {
  initCreativeOBDEnquiry();
}

document.addEventListener('shopify:section:load', (event) => initCreativeOBDEnquiry(event.target));
